var map = {
	"./Features-Block-Saved-DA-DK-D.avif": 42632,
	"./Features-Block-Saved-DE-DE-D.avif": 9886,
	"./Features-Block-Saved-EN-GB-D.avif": 79128,
	"./Features-Block-Saved-EN-US-D.avif": 40049,
	"./Features-Block-Saved-ES-ES-D.avif": 27736,
	"./Features-Block-Saved-ES-MX-D.avif": 53981,
	"./Features-Block-Saved-FR-FR-D.avif": 7316,
	"./Features-Block-Saved-IT-IT-D.avif": 77526,
	"./Features-Block-Saved-NB-NO-D.avif": 46623,
	"./Features-Block-Saved-NL-NL-D.avif": 10236,
	"./Features-Block-Saved-PL-PL-D.avif": 38600,
	"./Features-Block-Saved-PT-BR-D.avif": 67752,
	"./Features-Block-Saved-PT-PT-D.avif": 24696,
	"./Features-Block-Saved-SV-SE-D.avif": 98463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4312;